<div class="row tracking-popup">
  <div
    class="col-lg-12 shipment-summary-card"
    *ngIf="trackingHistoryList.length > 0">
    <i class="pi pi-truck shipment-summary-icon"></i>
    <div class="shipment-summary-main">
      <div class="shipment-summary-title">{{ shippingMethodName }}</div>
      <div class="shipment-summary-subtitle">
        Tracking #{{ trackingNumber }}
      </div>
    </div>
    <div class="shipment-summary-delivery" *ngIf="estDelivery">
      <div class="shipment-summary-delivery-label">Est. Delivery</div>
      <div class="shipment-summary-delivery-value">
        {{ estDelivery | date: "MMMM d, yyyy" }}
      </div>
    </div>
  </div>

  <div class="col-lg-12" *ngIf="trackingHistoryList.length <= 0">
    <p>No Record Found</p>
  </div>

  <div class="col-lg-12" *ngIf="trackingHistoryList.length > 0">
    <div
      class="status-pill"
      [class.in-transit]="
        latestStatusHistoryList[0]?.status?.toLowerCase() === 'in transit'
      ">
      <span class="status-dot"></span>
      {{ latestStatusHistoryList[0].status }}
    </div>

    <p-timeline [value]="latestStatusHistoryList">
      <ng-template pTemplate="marker">
        <span class="timeline-marker"><i class="pi pi-check"></i></span>
      </ng-template>
      <ng-template pTemplate="content" let-event>
        <div class="timeline-row">
          <div class="timeline-main">
            <div class="timeline-bold">{{ event.status }}</div>
            <div class="timeline-text">
              <i class="pi pi-map-marker"></i>{{ event.message }}
            </div>
          </div>
          <div class="timeline-date">
            {{ event.createdDate | date: "MMM d, yyyy" }} ·
            {{ event.createdDate | date: "h:mm a" }}
          </div>
        </div>
      </ng-template>
    </p-timeline>
  </div>
</div>

<div class="d-flex pt-3 justify-content-end gap-2">
  <p-button
    label="Back"
    (click)="onHide()"
    variant="outlined"
    severity="secondary" />
</div>

<!-- fixes/14757: original status line and timeline opposite template, replaced by the summary card / status pill / timeline-row above
<p>
  Status of Tracking Number :
  <span class="fw-bold">{{ trackingNumber }}</span>
</p>
<ng-template pTemplate="opposite" let-event>
  <div class="timeline-date">
    <div class="date-line">
      {{ event.createdDate | date: "MM-dd-yyyy" }}
    </div>
    <div class="time-line">{{ event.createdDate | date: "hh:mm a" }}</div>
  </div>
</ng-template>
-->
